<template>
  <div>
    <div class="container">
      <!--<div class="row" style="margin-top: 30px;margin-bottom:50px;">-->
      <!--<div class="col-md-12 we-desc">-->
      <!--<p class="text-center text-muted" style="font-size:16px;line-height:2.3;">稻草人旅行就是想要让你无论是在远方、亦或是在此地，都去能够体会旅行的快乐。-->
      <!--<br>用心打造的各种微旅行方式，和你的理想生活一样。-->
      <!--<br>这些微缩的旅行，也能带来超大的快乐。-->
      <!--<br><a href="/we" style="color:#337ab7">关于微旅行 了解更多</a>-->
      <!--</p>-->
      <!--</div>-->
      <!--</div>-->
      <!-- 搜索 -->
        <div id="myCarousel" class="carousel slide" v-show="cityNow === '上海'" data-interval="false">
          <!-- 轮播（Carousel）指标 -->
          <ol class="carousel-indicators">
            <li data-target="#myCarousel" data-slide-to="0" class="active"></li>
            <li data-target="#myCarousel" data-slide-to="1"></li>
          </ol>
          <!-- 轮播（Carousel）项目 -->
          <div class="carousel-inner" style="cursor: pointer;" >
            <div class="item active">
              <div>
                <video style="object-fit:fill;width: 100%; " @click="heightChange()" :height="mheight" id="myVideo"  controls poster="https://alistatic.54traveler.com/werulepc/page1/jiashiping.png" >
                  <!--<source src="https://alivideo.54traveler.com/video/54traveler_final.mp4"  type="video/mp4">-->
                  <source src="https://alistatic.54traveler.com/video/weSecondpc.mp4"  type="video/mp4">
                </video>
              </div>
              <!--<img src="https://gss0.baidu.com/7LsWdDW5_xN3otqbppnN2DJv/space/pic/item/6f061d950a7b02082bdbc9b16dd9f2d3572cc854.jpg" alt="Second slide">-->
            </div>
            <div class="item" >
              <img style="cursor: pointer;width: 100%;height:343px;" src="../assets/image/we/gomfirst.jpg" alt="Second slide" @click="gofirst()">
            </div>
          </div>
          <a class="left carousel-control" href="#myCarousel" role="button" data-slide="prev" style="height: 85%">
            <span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
          </a>
          <a class="right carousel-control" href="#myCarousel" role="button" data-slide="next" style="height: 85%">
            <span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
          </a>
        </div>

        <div id="myCarouse2" class="carousel slide" v-show="cityNow === '北京'" data-interval="false">
          <!-- 轮播（Carousel）指标 -->
          <ol class="carousel-indicators">
            <li data-target="#myCarouse2" data-slide-to="0" class="active"></li>
            <li data-target="#myCarouse2" data-slide-to="1"></li>
          </ol>
          <!-- 轮播（Carousel）项目 -->
          <div class="carousel-inner" style="cursor: pointer;" >
            <div class="item active" >
              <img style="cursor: pointer;width: 100%;height:343px;" src="https://dao-library.54traveler.com/cityplayer/pc-banner-beijing.jpg" alt="Second slide">
            </div>
            <div class="item" >
              <img style="cursor: pointer;width: 100%;height:343px;" src="../assets/image/we/gomfirst.jpg" alt="Second slide" @click="gofirst()">
            </div>
          </div>
          <a class="left carousel-control" href="#myCarouse2" role="button" data-slide="prev" style="height: 85%">
            <span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
          </a>
          <a class="right carousel-control" href="#myCarouse2" role="button" data-slide="next" style="height: 85%">
            <span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
          </a>
        </div>

        <div class="row" style="width: 100%;margin: 0 auto;margin-bottom: 40px;box-shadow: 0 5px 6px 0 #e2e2e2;">
          <div class="col-xs-12 text-muted">
            <div id="search" style="border: 0;">
              <ul class="list-inline">
                <ul class="list-inline" style="border-bottom:0;">
                  <li style="width: 50px;"> </li>
                  <li style="width: 100px;cursor: pointer;text-align: center;"><span style="color: #E60012;font-weight: bold;">城市</span></li>
                  <li style="cursor: pointer;text-align: center;" v-bind:class="{ 'menuselect' : cityNow === '上海'}" @click="menuCity('上海')">上海</li>
                  <li style="cursor: pointer;text-align: center;" v-bind:class="{ 'menuselect' : cityNow === '北京' }" @click="menuCity('北京')">北京</li>
                </ul>
                <ul class="list-inline" style="border-bottom:0;">
                  <li style="width: 50px;"> </li>
                  <li style="width: 100px;cursor: pointer;text-align: center;"><span style="color: #E60012;font-weight: bold;">推荐&福利</span></li>
                  <li style="width: 50px;cursor: pointer;text-align: center;" v-bind:class="{ 'menuselect' : menuselectA === 0 }" @click="menuA(0, '不限')">不限</li>
                  <li style="cursor: pointer;text-align: center;" v-bind:class="{ 'menuselect' : menuselectA === 1 }" @click="menuA(1, '活动系列')">活动系列</li>
                  <li style="cursor: pointer;text-align: center;" v-bind:class="{ 'menuselect' : menuselectA === 2 }" @click="menuA(2, '特别推荐')">特别推荐</li>
                  <li style="cursor: pointer;text-align: center;" v-bind:class="{ 'menuselect' : menuselectA === 3 }" @click="menuA(3, '福利优惠')">福利优惠</li>
                </ul>

                <!--  活动系列  -->
                <ul class="list-inline" v-show="menuselectA < 2" style="width: 80%;margin-left: 180px;border-bottom:0">
                  <li v-for="(key, val) in searchConfig.type" style="text-align: right;padding-bottom: 10px;" @click="menuAsecond(val.zhName, '活动系列')">
                    <label class="checkbox-inline selectNo" v-bind:class="{ 'selectOn' : mtypeType.indexOf(val.zhName) >= 0 }" v-if="val.id !== 7">
                      {{val.zhName}}{{val.enName}} <span style="display: none;"><input type="checkbox" :value="val.zhName" v-model="mtypeType"></span>
                    </label>
                    <!--<label class="checkbox-inline selectNo" v-if="val.id === 7" @click="govideo()">-->
                      <!--{{val.enLabel}}{{val.cnLabel}}-->
                    <!--</label>-->
                  </li>
                </ul>
                <!--  特别推荐  -->
                <ul class="list-inline" v-show="menuselectA === 2" style="width: 80%;margin-left: 180px;border-bottom:0">
                  <li v-for="(key, val) in searchConfig.recommend" style="text-align: right;padding-bottom: 10px;" @click="menuAsecond(val.name, '特别推荐')">
                    <label class="checkbox-inline selectNo" v-bind:class="{ 'selectOn' : mtypeRecommend.indexOf(val.name) >= 0 }">
                      {{val.name}}<span style="display: none;"><input type="checkbox" :value="val.name" v-model="mtypeRecommend"></span>
                    </label>
                  </li>
                </ul>
                <!--  福利优惠  -->
                <ul class="list-inline" v-show="menuselectA === 3" style="width: 80%;margin-left: 200px;border-bottom:0">
                  <li v-for="(key, val) in searchConfig.rule" style="text-align: right;padding-bottom: 10px;" @click="menuAsecond(val.name, '福利优惠')">
                    <label class="checkbox-inline selectNo" v-bind:class="{ 'selectOn' : mtypeRule.indexOf(val.name) >= 0 }">
                      {{val.name}}<span style="display: none;"><input type="checkbox" :value="val.name" v-model="mtypeRule"></span>
                    </label>
                  </li>
                </ul>
              </ul>
              <ul class="list-inline">
                <ul class="list-inline" style="border-bottom:0;">
                  <li style="width: 50px;"> </li>
                  <li style="width: 100px;cursor: pointer;text-align: center;"><span style="color: #E60012;font-weight: bold;">时间&名额</span></li>
                  <li style="width: 50px;cursor: pointer;text-align: center;" v-bind:class="{ 'menuselect' : menuselectB === 0 }" @click="menuB(0, '不限')">不限</li>
                  <li style="cursor: pointer;text-align: center;" v-bind:class="{ 'menuselect' : menuselectB === 1 }" @click="menuB(1, '活动时间')">活动时间</li>
                  <li style="cursor: pointer;text-align: center;" v-bind:class="{ 'menuselect' : menuselectB === 2 }" @click="menuB(2, '活动名额')">活动名额</li>
                </ul>
                <!--  活动时间  -->
                <ul class="list-inline" v-show="menuselectB < 2" style="width: 80%;margin-left: 200px;border-bottom:0">
                  <li v-for="(key, val) in menuTime" style="text-align: right;padding-bottom: 10px;" @click="menuBsecond(val, '活动时间')">
                    <label class="checkbox-inline selectNoSmall" v-bind:class="{ 'selectOnSmall' : mtypeTime.indexOf(val) >= 0 }">
                      {{val}}<span style="display: none;"><input type="checkbox" :value="val" v-model="mtypeTime"></span>
                    </label>
                  </li>
                </ul>

                <!--  活动名额  -->
                <ul class="list-inline" v-show="menuselectB === 2" style="width: 80%;margin-left: 200px;border-bottom:0">
                  <li v-for="(key, val) in menuHave" style="text-align: right;padding-bottom: 10px;" @click="menuBsecond(val, '活动名额')">
                    <label class="checkbox-inline selectNo" v-bind:class="{ 'selectOn' : mtypeHave.indexOf(val) >= 0 }">
                      {{val}}<span style="display: none;"><input type="checkbox" :value="val" v-model="mtypeHave"></span>
                    </label>
                  </li>
                </ul>
              </ul>

              <ul class="list-inline">
                <ul class="list-inline" style="border-bottom:0;">
                  <li style="width: 50px;"> </li>
                  <li style="width: 100px;cursor: pointer;text-align: center;"><span style="color: #E60012;font-weight: bold;">主题&方式</span></li>
                  <li style="width: 50px;cursor: pointer;text-align: center;" v-bind:class="{ 'menuselect' : menuselectC === 0 }" @click="menuC(0, '不限')">不限</li>
                  <li style="cursor: pointer;text-align: center;" v-bind:class="{ 'menuselect' : menuselectC === 1 }" @click="menuC(1, '活动主题')">活动主题</li>
                  <li style="cursor: pointer;text-align: center;" v-bind:class="{ 'menuselect' : menuselectC === 2 }" @click="menuC(2, '活动方式')">活动方式</li>
                </ul>

                <!--  活动主题  -->
                <ul class="list-inline" v-show="menuselectC < 2" style="width: 80%;margin-left: 200px;border-bottom:0">
                  <li v-for="(key, val) in searchConfig.theme" style="text-align: right;padding-bottom: 10px;" @click="menuCsecond(val.name, '活动主题')">
                    <label class="checkbox-inline selectNoSmall" v-bind:class="{ 'selectOnSmall' : mtypeTheme.indexOf(val.name) >= 0 }">
                      {{val.name}}<span style="display: none;"><input type="checkbox" :value="val.name" v-model="mtypeTheme"></span>
                    </label>
                  </li>
                </ul>

                <!--  活动方式  -->
                <ul class="list-inline" v-show="menuselectC === 2" style="width: 80%;margin-left: 200px;border-bottom:0">
                  <li v-for="(key, val) in searchConfig.way" style="text-align: right;padding-bottom: 10px;" @click="menuCsecond(val.name, '活动方式')">
                    <label class="checkbox-inline selectNoSmall" v-bind:class="{ 'selectOnSmall' : mtypeWay.indexOf(val.name) >= 0 }">
                      {{val.name}}<span style="display: none;"><input type="checkbox" :value="val.name" v-model="mtypeWay"></span>
                    </label>
                  </li>
                </ul>
              </ul>
              <ul class="list-inline" style="margin-top: 10px;margin-bottom: 10px;">
                  <li style="width: 68%;"></li>
                  <li style="width: 30%;">
                    <div class="menuGo" @click="resetlist()">清除已选</div>
                    <div class="menuGo" @click="searchWelist(1)">确&nbsp;&nbsp;&nbsp;&nbsp;定</div>
                  </li>
              </ul>
            </div>
          </div>
        </div>
    </div>
    <div class="container" style="margin-bottom: 70px;margin-top: 20px;">
       <div class="row margin-bottom">
        <div class="col-xs-4" v-for="route in list" track-by="$index">
          <div class="mostPopular" v-if="route.recommendLabel !== ''"  :style="'background-color:' + route.labelColor + ';position: absolute;z-index: 10;'">{{route.recommendLabel}}</div>
          <a @click="godetail(route.originalId)">
            <div class="trip" style="position: relative;z-index: 1">
              <figure style="height:223px;">
                <img src="https://dao-library.54traveler.com/dcr-common/full.png" class="fullimage" v-show="route.surplusSize === 0">
                <img :src="route.coverPicture" style="height:233px;">
                <figcaption style="top:30px;">
                  <p>{{route.hoverIntroduce | ellipsis 73}}
                    <br>
                    <span class="location" style="">
                      <i class="fa fa-map-marker"></i>{{route.city}} {{route.area}}</span></p>
                </figcaption>
              </figure>
              <div class="trip-info" style="margin-bottom: 5px;">
                <h4 :title="route.title" class="ellipsis">{{route.heading}}</h4>
                <p class="brand-red">
                  {{route.typeEnLabel}} · {{route.typeZhLabel}}
                  <span class="pull-right" v-if="route.id">{{route.priceText}}<span v-if="route.unit">/{{route.unit}}</span></span>
                </p>
                <p class="text-muted" v-if="route.tripWideMany.length">
                  <span v-for="ruleb in route.ruleLabels"  track-by="$index" class="ruleb">{{ruleb === '新人立减50' ? '新人立减￥50' : ruleb}}</span>
                  <span class="pull-right"><span class="fa fa-calendar"></span>
                    <span v-for="date in route.tripWideMany | limitBy 1" track-by="$index">{{date.startDate | moment 'M[.]DD'}}
                      <span v-show="$index !== route.tripWideMany.length - 1"> | </span></span>
                    <span v-show="route.tripWideMany.length > 1">更多</span>
                  </span>
                </p>
                <p class="text-muted" v-if="!route.tripWideMany.length">
                  <span v-for="ruleb in route.ruleLabels"  track-by="$index" class="ruleb">{{ruleb === '新人立减50' ? '新人立减￥50' : ruleb}}</span>
                  <span class="pull-right" v-if="route.surplusSize === 0"><span class="fa fa-calendar"></span>已报满</span>
                </p>
              </div>
              <span v-show="route.isOnSale" class="sales"></span>
            </div>
          </a>
        </div>
      </div>
      <nav class="text-center">
        <ul class="pagination">
          <li v-for="item in totalPage" :class="{active: page === ($index + 1)}"><a @click="searchWelist($index + 1)">{{$index + 1}}</a></li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
  import config from '../libs/config.js'
  import cache from '../libs/cache'
  import Carousel from '../components/Carousel'
  import Slider from '../components/Slider'
  import _ from 'lodash'
  import $ from 'jquery'
  let searchConfig = {
    recommend: [],
    rule: [],
    theme: [],
    type: [],
    way: []
  }

  let search = {
    catalog: [],
    theme: [],
    city: '上海',
    cityBlock: [],
    start: []
  }

  let bannerlist = [
    {
      image: 'https://alistatic.54traveler.com/werulepc/page1/jiashiping.png',
      video: 'https://alistatic.54traveler.com/video/weSecondpc.mp4',
      bannerType: 'video'
    },
    {
      image: '../assets/image/we/gomfirst.jpg',
      video: '',
      bannerType: 'image'
    },
    {
      image: 'https://alistatic.54traveler.com/werulepc/banner.jpg',
      video: '',
      bannerType: 'image'
    }
  ]

  export default {
    ready () {
      $('.carousel').carousel()
    },
    components: {
      Carousel,
      Slider
    },
    data () {
      return {
        mheight: '343px',
        mytime_02: true,
        menuselectA: 1,
        menuselectB: 1,
        menuselectC: 1,
        mtypeRecommend: [],
        mtypeRule: [],
        mtypeTheme: [],
        mtypeType: [],
        mtypeWay: [],
        mtypeTime: [],
        mtypeHave: [],
        cityNow: this.$route.params.city,
        menuTime: ['本周', '下周', '两周后'],
        menuHave: ['仅看有名额'],
        videoPreviewLoading: false,
        categories: config.categories,
        categoriesCN: config.categoriesCN,
        defaultSearch: {},
        search: _.cloneDeep(search),
        bannerlist: _.cloneDeep(bannerlist),
        oldSearch: _.cloneDeep(search),
        selectArea: {},
        isShowDropdown: false,
        searchConfig,
        list: [],
        images: [],
        bezhu: 'ss',
        page: 1,
        totalPage: 1,
        isSelectAll: false,
        xhr: null,
        playerOptions: {
          muted: false,
          language: 'zh-CN',
          aspectRatio: '16:9',
          playbackRates: [0.7, 1.0, 1.5, 2.0],
          sources: [{
            type: 'video/mp4',
            src: 'https://alivideo.54traveler.com/video/54traveler_final.mp4'
          }],
          fluid: true,
          poster: '../assets/image/we/second.jpg',
          notSupportedMessage: '此视频暂无法播放，请稍后再试'
        }
      }
    },
    methods: {
      heightChange () {
        this.sensorscommon.weTravelClient('视频播放按钮')
        this.mheight = 'auto'
      },
      godetail (originalId) {
        var url = process.env.HOME_URL + '/detail/' + originalId
        window.open(url)
      },
      govideo () {
        var url = '/online'
        window.open(url)
      },
      gofirst () {
        var url = '/mfirst'
        console.log(url)
        window.open(url)
      },
      gorecomd () {
        var url = '/weRule'
        window.open(url)
      },
      searchWelist (page) {
        this.page = page
        let params = {
          pageScene: 'page',
          pageIndex: page,
          pageSize: 9
        }
        var mtypeTimeGo = ''
        if (this.mtypeTime) {
          this.mtypeTime.forEach((item) => {
            if (mtypeTimeGo === '') {
              mtypeTimeGo = item
            } else {
              mtypeTimeGo = mtypeTimeGo + ',' + item
            }
          })
          if (mtypeTimeGo !== '') {
            params.rangeWeeks = mtypeTimeGo
          }
        }
        var mtypeTypeGo = ''
        if (this.mtypeType) {
          this.mtypeType.forEach((item) => {
            if (mtypeTypeGo === '') {
              mtypeTypeGo = item
            } else {
              mtypeTypeGo = mtypeTypeGo + ',' + item
            }
          })
          if (mtypeTypeGo !== '') {
            params.typeLabels = mtypeTypeGo
          }
        }
        var mtypeRecommendGo = ''
        if (this.mtypeRecommend) {
          this.mtypeRecommend.forEach((item) => {
            if (mtypeRecommendGo === '') {
              mtypeRecommendGo = item
            } else {
              mtypeRecommendGo = mtypeRecommendGo + ',' + item
            }
          })
          if (mtypeRecommendGo !== '') {
            params.recommendLabels = mtypeRecommendGo
          }
        }
        var mtypeRuleGo = ''
        if (this.mtypeRule) {
          this.mtypeRule.forEach((item) => {
            if (mtypeRuleGo === '') {
              mtypeRuleGo = item
            } else {
              mtypeRuleGo = mtypeRuleGo + ',' + item
            }
          })
          if (mtypeRuleGo !== '') {
            params.ruleLabels = mtypeRuleGo
          }
        }
        var mtypeThemeGo = ''
        if (this.mtypeTheme) {
          this.mtypeTheme.forEach((item) => {
            if (mtypeThemeGo === '') {
              mtypeThemeGo = item
            } else {
              mtypeThemeGo = mtypeThemeGo + ',' + item
            }
          })
          if (mtypeThemeGo !== '') {
            params.themeLabels = mtypeThemeGo
          }
        }
        var mtypeWayGo = ''
        if (this.mtypeWay) {
          this.mtypeWay.forEach((item) => {
            if (mtypeWayGo === '') {
              mtypeWayGo = item
            } else {
              mtypeWayGo = mtypeWayGo + ',' + item
            }
          })
          if (mtypeWayGo !== '') {
            params.wayLabels = mtypeWayGo
          }
        }
        var mtypeHaveGo = 0
        if (this.mtypeHave) {
          this.mtypeHave.forEach((item) => {
            mtypeHaveGo = item
          })
          if (mtypeHaveGo !== '' && mtypeHaveGo !== 0) {
            mtypeHaveGo = 1
          }
        }
        params.hasQuota = mtypeHaveGo
        params.city = this.cityNow

        // let params = {
        //   typeLabelIds: mtypeTypeGo,  /*  活动系列 */
        //   recommendLabelIds: mtypeRecommendGo,  /*  特别推荐 */
        //   ruleLabelIds: mtypeRuleGo,  /*  福利优惠 */
        //   range: mtypeTimeGo,  /*  活动时间 */
        //   isQuota: mtypeHaveGo,  /*  活动名额 */
        //   themeLabelIds: mtypeThemeGo,  /*  活动主题 */
        //   wayLabelIds: mtypeWayGo,  /*  活动方式 */
        //   paginate: 'yes',
        //   page: this.$route.query.page || 1
        // }
        return this.$http.get(`${config.apiRoute}/sku-wide?catalog=WE`, params, {
          beforeSend (xhr) {
            if (this.xhr) {
              this.xhr.cancel()
            }
            this.xhr = xhr
          }
        })
          .then(({data}) => {
            data.list = data.data.page || []
            console.log(data.list)
            data.list.forEach((item) => {
              item.trip = Object.keys(item.trip || {})
              item.priceText = this.getPriceText(item)
            })
            this.$set('list', data.list)
            this.$set('totalPage', data.data.pagination.totalPage)
          })
          .catch((e) => {
            console.error(e)
          })
      },
      resetlist () {
        let params = {
          pageScene: 'page',
          city: this.cityNow,
          pageIndex: this.$route.query.page || 1,
          pageSize: 9
        }
        this.mtypeType = []
        this.mtypeRecommend = []
        this.mtypeRule = []
        this.mtypeTime = []
        this.mtypeHave = []
        this.mtypeTheme = []
        this.mtypeWay = []
        this.cityNow = '上海'
        this.menuselectA = 1
        this.menuselectB = 1
        this.menuselectC = 1
        return this.$http.get(`${config.apiRoute}/sku-wide?catalog=WE`, params, {
          beforeSend (xhr) {
            if (this.xhr) {
              this.xhr.cancel()
            }
            this.xhr = xhr
          }
        })
          .then(({data}) => {
            data.list = data.data.page || []
            data.list.forEach((item) => {
              item.trip = Object.keys(item.trip || {})
              item.priceText = this.getPriceText(item)
            })
            this.$set('list', data.list)
            this.$set('totalPage', data.data.pagination.totalPage)
          })
          .catch((e) => {
            console.error(e)
          })
      },
      menuCity (item) {
        this.cityNow = item
        this.fetchThemes()
      },
      menuAsecond (item, firstName) {
        console.log(item)
        this.sensorscommon.weTravelFilterClient('recommend_second', item, firstName)
      },
      menuA (item, tabName) {
        this.sensorscommon.weTravelFilterClient('recommend_first', tabName)
        this.menuselectA = item
        this.mtypeType = []
        this.mtypeRecommend = []
        this.mtypeRule = []
      },
      menuBsecond (item, firstName) {
        this.sensorscommon.weTravelFilterClient('date_second', item, firstName)
      },
      menuB (item, tabName) {
        this.sensorscommon.weTravelFilterClient('date_first', tabName)
        this.menuselectB = item
        this.mtypeTime = []
        this.mtypeHave = []
      },
      menuCsecond (item, firstName) {
        this.sensorscommon.weTravelFilterClient('theme_second', item, firstName)
      },
      menuC (item, tabName) {
        this.sensorscommon.weTravelFilterClient('theme_first', tabName)
        this.menuselectC = item
        this.mtypeTheme = []
        this.mtypeWay = []
      },
      selectAll (item) {
        if (item.isSelectAll) {
          item.cityBlock = item.sub.slice()
        } else {
          item.cityBlock = []
        }
        this.changeSearch()
      },
      detectSelectAll (item) {
        if (item.cityBlock.length === item.sub.length) {
          item.isSelectAll = true
        } else {
          item.isSelectAll = false
        }
        this.changeSearch()
      },
      changeSearch () {
        let cityBlock = []
        let city = []
        this.searchConfig.areas.forEach((item) => {
          if (item.isSelectAll) {
            city.push(item.name)
          } else {
            cityBlock.push(...item.cityBlock)
          }
        })
        this.search.city = city
        this.search.cityBlock = cityBlock
      },
      fetchRoutes () {
        let params = {
          pageScene: 'page',
          pageIndex: this.$route.query.page || 1,
          pageSize: 9
        }
        Object.assign(params, this.search)

        Object.keys(params)
          .forEach((key) => {
            if (Array.isArray(params[key])) {
              params[key] = params[key].join(',')
            }
            if (!params[key]) {
              delete params[key]
            }
          })
        params.city = this.cityNow
        return this.$http.get(`${config.apiRoute}/sku-wide?catalog=WE`, params, {
          beforeSend (xhr) {
            if (this.xhr) {
              this.xhr.cancel()
            }
            this.xhr = xhr
          }
        })
          .then(({data}) => {
            data.list = data.data.page || []
            data.list.forEach((item) => {
              item.trip = Object.keys(item.trip || {})
              item.priceText = this.getPriceText(item)
            })
            this.$set('list', data.list)
            this.$set('totalPage', data.data.pagination.totalPage)
          })
          .catch((e) => {
            console.error(e)
          })
      },
      fetchCarousel () {
        let params = {
          parentId: 0
        }
        return this.$http.get(`${config.apiWe}/product/slider`, params)
          .then(({data}) => {
            if (data.length) {
              this.$set('images', data[0].images)
            }
          })
      },
      fetchThemes () {
        if (!this.cityNow) {
          this.cityNow = '上海'
        }
        return this.$http.get(`${config.apiRoute}/sku-wide/condition?catalog=WE&city=` + this.cityNow)
          .then(({data}) => {
            this.$set('searchConfig.rule', data.data.ruleLabelOption)
            this.$set('searchConfig.recommend', data.data.recommendLabelOption)
            this.$set('searchConfig.theme', data.data.themeLabelOption)
            this.$set('searchConfig.type', data.data.typeLabelOption)
            this.$set('searchConfig.way', data.data.wayLabelOption)
          })
      },
      toggleCityBlock (areas, city) {
        areas.forEach((item) => {
          if (item.name === city.name) {
            if (!item.select) {
              item.select = true
            } else {
              item.select = false
            }
          } else {
            item.select = false
          }
        })
      },
      getPriceText ({ maxPrice, minPrice, dailyPrice, trip }) {
        maxPrice = maxPrice * 1
        minPrice = minPrice * 1
        dailyPrice = dailyPrice * 1
        if (maxPrice <= 0) {
          return ''
        }
        if (maxPrice === minPrice) {
          return '￥' + maxPrice
        }
        return '￥' + minPrice + '-' + maxPrice
      }
    },
    watch: {
      search: {
        handler (val, oldval) {
          // 手动对比 val 和 oldval
          if (JSON.stringify(val) === JSON.stringify(this.oldSearch)) {
            return
          }
          this.oldSearch = _.cloneDeep(val)
          if (this.$route.query.page && +this.$route.query.page !== 1) {
            this.$route.router.go({
              query: {
                page: 1
              }
            })
          }
          this.fetchRoutes()
        },
        deep: true
      }
    },
    route: {
      data () {
        // window.localStorage.clear()
        Object.assign(this.$data, cache.get() || {})
        if (!this.cityNow) {
          this.cityNow = '上海'
        }
        return Promise.all([this.fetchRoutes(), this.fetchCarousel(), this.fetchThemes()])
          .then(() => {
            this.$nextTick(() => {
              cache.set(this.$data)
            })
          }, (e) => {
            console.error(e)
          })
      }
    }
  }
</script>
<style scoped>
  @import '../assets/css/second.css';
  .pointer {
    cursor: pointer;
  }
  .container{
    width: 1120px;
  }
  .menuli {
    width: 100px;
  }
  .mostPopular {
    min-width: 90px;
    height: 30px;
    margin-top: 20px;
    font-size: 14px;
    font-weight: bold;
    border-top-right-radius: 30px;
    text-align: center;
    border-bottom-right-radius: 30px;
    letter-spacing: 2px;
    color: white;
    padding: 3px 10px 3px 10px;
  }
  .menuselect {
    color: #E60012;
    font-weight: bold;
  }
  .selectOn {
    padding-left:0px;
    cursor: pointer;
    text-align: center;
    background-color: #E60012;
    color: #ffffff;
    min-width: 100px;
    padding: 0 0.5em;
  }
  .selectNo {
    padding-left:0px;
    cursor: pointer;
    text-align: center;
    min-width: 100px;
    padding: 0 0.5em;
  }
  .selectOnSmall {
    padding-left:0px;
    cursor: pointer;
    text-align: center;
    background-color: #E60012;
    color: #ffffff;
    min-width: 80px;
    padding: 0 0.5em;
  }
  .selectNoSmall {
    padding-left:0px;
    cursor: pointer;
    text-align: center;
    min-width: 80px;
    padding: 0 0.5em;
  }
  .menuGo {
    width: 100px;
    height: 40px;
    line-height: 40px;
    margin-left: 10px;
    margin-top: 10px;
    text-align: center;
    float: right;
    background-color: #E60012;
    border-radius: 25px;
    color: #ffffff;
    cursor: pointer;
  }
  .ruleb {
    float: left;
    color: #E60012;
    border: 1px solid #f4f4f4;
    min-width: 100px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    background-color: #f4f4f4;
    margin-right: 5px;
    margin-top: -4px;
    padding: 0 4px;
  }
  .fullimage {
    right: 1.5em;
    bottom: 1.5em;
    width: 70px;
    height: 70px;
    position: absolute;
  }
</style>



/** WEBPACK FOOTER **
 ** Second.vue?2a1cadfa
 **/